<template>
  <div>

  </div>
</template>

<script>
  import g from '@/components/Global.vue'
  import GlobalConfig from '@/components/Global.config.vue'
  import bus from '@/assets/eventBus'
  import axios from '@/axios'
  export default {
    name: 'socket',
    data() {
      return {
        socketData: [], //用于向未接传递转换后的数据
        nameData: [], //用于提取品种名
        priceData: [], //用于提取价格等信息
        responseData: [], //用于存储推送过来的数据
        configs: [],  //用于存储远期配置数据
        sub: '',  //用于记录过滤所需的子账
        flag: false,  //用于判断是否进入过远期界面
        list: [],
        ws: '',
      }
    },
    created() {
      // this.periodic()
    },
    methods: {
      periodic(){
        setTimeout(() => {
          this.Socket(this.configs)
          this.periodic()
        },3000)
      },
      getforwardConfig() {
        return new Promise((reslove, reject) => {
          axios.post('client/inner/forwardconfig/queryAll.do').then(result => {
            if (result.data.success) {
              let arr = result.data.ForwardConfigs
              let datas = []
              if(this.sub) {
                arr.forEach(item => {
                  if(item.subAccountNo == this.sub) {
                    datas.push(item)
                  }
                })
                this.configs = datas
                reslove(datas)
              } else {
                reslove(arr)
              }
              
            }
          })
        })
      },
      // 查询行情
      Socket (params) {
        let _this = this
        const ws = new WebSocket(g.underlyingMarketDataServe)
        this.ws = ws
        let list = GlobalConfig.changeList(params)
        this.list = list
        ws.onopen = function (e) {
          this.send(`{"messageType":"${GlobalConfig.optionType.request.requestMarket}","messageData":{"code_list":[${list}]}}`)
          this.send(`{"messageType":"${GlobalConfig.optionType.request.requestCodeInfo}","messageData":{"code_list":[${list}]}}`)
          this.send(`{"messageType":"${GlobalConfig.optionType.push.pushMarket}","messageData":{"code_list":[${list}]}}`)
          setInterval(() => {
            if(this.readyState === 1) {
              this.send(JSON.stringify({messageType: "HEARTBEAT"}))
            }
          }, 20000)
        }
        ws.onmessage = function (e) {
          let type = JSON.parse(e.data).messageType
          if (type == GlobalConfig.optionType.response.initCodeInfo) {
            _this.nameData = JSON.parse(e.data).messageData.instrument
          }
          if (type == GlobalConfig.optionType.response.initMarket) {
            _this.priceData = JSON.parse(e.data).messageData.market_data
          }
          if (type == GlobalConfig.optionType.response.pushType) {
            let arr = JSON.parse(e.data).messageData.market_data
            _this.changeSocket(arr)
            return
          }

          let arr = []
          params.forEach(list => {
            // list = JSON.parse(list)
            let n = list.priceAccuracy
            let obj = {
              market: list.exchange,
              code: list.underlying,
              priceAccuracy: list.priceAccuracy,
            }
            _this.nameData.forEach(item => {
              if (item.exchange_id == list.exchange && item.instrument_id == list.underlying) {
                // obj['name'] = item.instrument_name
                obj['name'] = item.product_id
              }
            })
            _this.priceData.forEach(item => {
              if (item.exchange_id == list.exchange && item.instrument_id == list.underlying) {
                item.ask_price.forEach(ask => {
                  ask = ask.toFixed(n)
                })
                item.bid_price.forEach(bid => {
                  bid = bid.toFixed(n)
                })

                //========================      以下几个字段可能没有值,故做一下处理           ====================================
                let lowest_price = item.lowest_price    //最低价
                let highest_price = item.highest_price    //最高价
                let open_price = item.open_price    //开盘价
                let last_price = item.last_price    //最新价
                let close_price = item.close_price    //收盘价
                let pre_settlement_price = item.pre_settlement_price  //前结算价
                let pre_close_price = item.pre_close_price    //前收盘价
                let upper_limit_price = item.upper_limit_price    //
                let lower_limit_price = item.lower_limit_price    //
                
                if(!lowest_price) {
                  lowest_price = '--'
                } else {
                  lowest_price = lowest_price.toFixed(n)
                }

                if(!highest_price) {
                  highest_price = '--'
                } else {
                  highest_price = highest_price.toFixed(n)
                }

                if(!open_price) {
                  open_price = '--'
                } else {
                  open_price = open_price.toFixed(n)
                }

                if(!last_price) {
                  last_price = '--'
                } else {
                  last_price = last_price.toFixed(n)
                }
                if(!close_price) {
                  close_price = '--'
                } else {
                  close_price = close_price.toFixed(n)
                }
                if(!pre_settlement_price) {
                  pre_settlement_price = '--'
                } else {
                  pre_settlement_price = pre_settlement_price.toFixed(n)
                }
                if(!pre_close_price) {
                  pre_close_price = '--'
                } else {
                  pre_close_price = pre_close_price.toFixed(n)
                }
                if(!upper_limit_price) {
                  upper_limit_price = '--'
                } else {
                  upper_limit_price = upper_limit_price.toFixed(n)
                }
                if(!lower_limit_price) {
                  lower_limit_price = '--'
                } else {
                  lower_limit_price = lower_limit_price.toFixed(n)
                }


                obj['price'] = last_price
                obj['ask_price'] = item.ask_price
                obj['ask_volume'] = item.ask_volume
                obj['bid_price'] = item.bid_price
                obj['bid_volume'] = item.bid_volume
                obj['close_price'] = close_price
                obj['highest_price'] = highest_price
                obj['lower_limit_price'] = lower_limit_price
                obj['lowest_price'] = lowest_price
                obj['open_price'] = open_price
                obj['pre_close_price'] = pre_close_price
                obj['pre_settlement_price'] = pre_settlement_price
                obj['upper_limit_price'] = upper_limit_price

                obj['update_millisec'] = item.update_millisec     //行情更新时间
                obj['update_time'] = item.update_time     //行情更新时间

                obj['exchange_id'] = item.exchange_id
                obj['instrument_id'] = item.instrument_id
              }
            })
            if (obj.name && obj.price) {
              arr.push(obj)
            }
          })

          if (!arr.length) {
            return
          }
          _this.socketData = arr
          _this.$store.dispatch("changeSockets", arr)

          bus.$emit("sockets", arr)

        }
        ws.onerror = function (e) {

        }
        ws.onclose = function (e) {

        }
      },
      // 订阅推送行情（用于盘冲时)
      changeSocket(arr){
        this.socketData.forEach(item => {
          if(item.market == arr[0].exchange_id && item.code == arr[0].instrument_id){
            let n = item.priceAccuracy    //获取价格精度
            let ask_price = []
            let bid_price = []
            arr[0].ask_price.forEach(ask => {
              ask_price.push(ask.toFixed(n))
            })
            arr[0].bid_price.forEach(bid => {
              bid_price.push(bid.toFixed(n))
            })

            //========================      以下几个字段可能没有值,故做一下处理           ====================================
            let lowest_price = arr[0].lowest_price    //最低价
            let highest_price = arr[0].highest_price    //最高价
            let open_price = arr[0].open_price    //开盘价
            let last_price = arr[0].last_price    //最新价
            let close_price = arr[0].close_price    //收盘价
            let pre_settlement_price = arr[0].pre_settlement_price  //前结算价
            let pre_close_price = arr[0].pre_close_price    //前收盘价
            let upper_limit_price = arr[0].upper_limit_price    //
            let lower_limit_price = arr[0].lower_limit_price    //
            
            if(!lowest_price) {
              lowest_price = '--'
            } else {
              lowest_price = lowest_price.toFixed(n)
            }

            if(!highest_price) {
              highest_price = '--'
            } else {
              highest_price = highest_price.toFixed(n)
            }

            if(!open_price) {
              open_price = '--'
            } else {
              open_price = open_price.toFixed(n)
            }
            if(!last_price) {
              last_price = '--'
            } else {
              last_price = last_price.toFixed(n)
            }
            if(!close_price) {
              close_price = '--'
            } else {
              close_price = close_price.toFixed(n)
            }
            if(!pre_settlement_price) {
              pre_settlement_price = '--'
            } else {
              pre_settlement_price = pre_settlement_price.toFixed(n)
            }
            if(!pre_close_price) {
              pre_close_price = '--'
            } else {
              pre_close_price = pre_close_price.toFixed(n)
            }
            if(!upper_limit_price) {
              upper_limit_price = '--'
            } else {
              upper_limit_price = upper_limit_price.toFixed(n)
            }
            if(!lower_limit_price) {
              lower_limit_price = '--'
            } else {
              lower_limit_price = lower_limit_price.toFixed(n)
            }
            //=================================================
            item.price = last_price
            item['ask_price'] = ask_price
            item['ask_volume'] = arr[0].ask_volume
            item['bid_price'] = bid_price
            item['bid_volume'] = arr[0].bid_volume
            item['close_price'] = close_price
            item['highest_price'] = highest_price
            item['lower_limit_price'] = lower_limit_price
            item['lowest_price'] = lowest_price
            item['open_price'] = open_price
            item['pre_close_price'] = pre_close_price
            item['pre_settlement_price'] = pre_settlement_price
            item['upper_limit_price'] = upper_limit_price

            item['update_millisec'] = arr[0].update_millisec     //行情更新时间
            item['update_time'] = arr[0].update_time     //行情更新时间

            bus.$emit("pusher", item)
          }
        })
        
      },
      // 查询交易日
      restDay () {
        return new Promise((reslove, reject) => {
          axios.get("client/inner/festivalconfig/queryFestivalList.do").then(result => {
            let restDays = JSON.parse(result.data.festivalConfig).exchange_rest_day[0].rest_day
            bus.$emit('restDay', restDays)
            reslove()
          })
        })
      },

      livePage() {
        this.flag = false
        // this.ws.onopen = function (e) {
        this.ws.send(`{"messageType":${GlobalConfig.optionType.cancel.cancelMarket}},"messageData":{"code_list":[${this.list}]}}}`)
        // }
      },
    },
    destroyed() {
      this.livePage()
    },
    watch: {
      $route: {
        handler(to, from) {
          if (to.path == '/forwardType') {
            // this.Socket()
            this.sub = to.query.sub
            this.flag = true
            this.getforwardConfig().then((configs) => {
              this.Socket(configs)
            })
            this.restDay()
          } else {
            if(!this.flag) return
            this.livePage()
          }
        },
        immediate: true
      }
    },
  }

</script>

<style>

</style>
